import { Controller } from "@hotwired/stimulus";
import { openPopover } from "../lib/bubble";

/**
 * Un panneau `popover` natif ouvert contre son déclencheur (lib/bubble#openPopover) : un menu,
 * une liste de choix. Le navigateur le ferme au clic dehors et sur Échap ; `close` le ferme
 * après un choix. Le déclencheur porte `aria-expanded`, que le composant stylise.
 *
 *   <div data-controller="anchored-popover">
 *     <button data-anchored-popover-target="trigger" data-action="anchored-popover#toggle"
 *             aria-expanded="false">…</button>
 *     <div popover="auto" data-anchored-popover-target="panel"
 *          data-action="toggle->anchored-popover#toggled">
 *       <button data-action="… anchored-popover#close">…</button>
 *     </div>
 *   </div>
 */
export default class extends Controller {
  static targets = ["trigger", "panel"];

  disconnect() {
    this.closePanel?.();
  }

  toggle() {
    if (this.panelTarget.matches(":popover-open")) return this.close();
    this.closePanel = openPopover(this.triggerTarget, this.panelTarget);
  }

  close() {
    this.closePanel?.();
    this.closePanel = null;
  }

  /** Le navigateur l'a ouvert ou fermé : le déclencheur le dit. */
  toggled(e) {
    const open = e.newState === "open";
    this.triggerTarget.setAttribute("aria-expanded", String(open));
    if (!open) this.closePanel = null;
  }
}
